var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _ellipse3, _ellipse4, _path16, _path17, _path18, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 887,
    height: 513,
    viewBox: "0 0 887 513",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 489.507L20 393.303L116.5 407.879L61 477.846L45.5 428.772L0 489.507Z",
    fill: "#FF3416"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4263 50.2709L453.889 113.364L388.963 475.309L16.5 412.216L81.4263 50.2709Z",
    fill: "#3FAC8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4263 50.2709L453.889 113.364L388.963 475.309L16.5 412.216L81.4263 50.2709Z",
    fill: "#3FAC8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4263 50.2709L453.889 113.364L388.963 475.309L16.5 412.216L81.4263 50.2709Z",
    fill: "#3FAC8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4263 50.2709L453.889 113.364L388.963 475.309L16.5 412.216L81.4263 50.2709Z",
    fill: "#3FAC8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.276 6.59338L335.231 114.218L369.169 124.23L454.203 64.7444L446.807 56.2645L427.077 62.1402L435.76 44.9084L427.292 37.012L402.394 51.2593L421.891 30.9201L408.605 18.0036L393.395 36.009L399.988 13.6621L391.276 6.59338Z",
    fill: "#3FAC8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1062 269.889L83.0353 297.905",
    stroke: "black",
    strokeWidth: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.317 278.457L93.8243 302.942",
    stroke: "black",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.202 296.601L98.5 312.386",
    stroke: "black",
    strokeWidth: 8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76,
    cy: 321.878,
    rx: 28.5,
    ry: 27.6952,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71,
    cy: 319.935,
    rx: 13.5,
    ry: 13.1188,
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.6 82.1701L152.242 263.615L298.949 359.948L447.973 187.7L281.089 212.308L255.6 82.1701Z",
    fill: "#3E51C1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M892.91 85.4576L763.418 108.704L773.672 214.401L916.552 215.908L839.078 148.266L892.91 85.4576Z",
    fill: "#3E3092"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 378.026,
    height: 367.458,
    transform: "matrix(0.997579 0.0695498 -0.0736291 0.997286 438.89 76.007)",
    fill: "#FF3416"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M890.341 379.276L769 379.848L775.959 414.541L868.219 462.052L872.275 451.556L857.881 436.839L877.174 436.49L880.214 425.318L856.004 409.929L883.086 417.7L888.322 399.926L865.304 394.86L888.148 390.278L890.341 379.276Z",
    fill: "#FF3416"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M533.606 95.9437L521.535 123.959",
    stroke: "black",
    strokeWidth: 8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M550.817 104.511L532.324 128.997",
    stroke: "black",
    strokeWidth: 8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M563.702 122.655L537 138.441",
    stroke: "black",
    strokeWidth: 8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 514.5,
    cy: 147.933,
    rx: 28.5,
    ry: 27.6952,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 509.5,
    cy: 145.989,
    rx: 13.5,
    ry: 13.1188,
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M341.826 78.5104L442.793 76.0199L449.674 170.685L349.826 165.425L410.826 122.181L341.826 78.5104Z",
    fill: "#F7CB25"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M601 466.185V373.867L610 369.008V466.185L625 469.1V478.817L613 472.987L619 492.422H610L604 472.987L593 478.817L588 472.987L601 466.185Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M650.946 486.592V394.274L641.216 389.415V486.592L625 489.507V499.224L637.973 493.394L631.486 512.829H641.216L647.703 493.394L659.595 499.224L665 493.394L650.946 486.592Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.848 426.342H228.283L215.828 471.043H201V486.592L218.2 482.219L206.041 508.942H215.828L227.097 482.219L239.848 497.281L244 486.592L233.324 474.93L239.848 426.342Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPta);
export default __webpack_public_path__ + "static/media/pta.9700f74f3756295ffbbff356f652e27f.svg";
export { ForwardRef as ReactComponent };